module.exports = __webpack_public_path__ + "static/img/en-US.30329586.png";